import React from "react";

import {
  TextField,
  Button,
  FormControl,
  Paper,
  Grid,
  IconButton,
  Typography,
  Box,
} from "@mui/material";

import Treeview from "./utils/Treeview";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

import { extractIDsFromGraph } from "./utils/applibs";
import { GraphNode } from "../modules/Graph";

export default function AdminCategory(props) {
  const {
    title,
    description,
    graph,
    currentItem,
    onTitleChange,
    onDescriptionChange,
    onGraphChange,
    submitting,
    onCancelAction,
    onNodeSave,
  } = props;

  const { id = null } = currentItem || {};
  let graphClone = { ...graph };

  const [selected, setSelected] = React.useState([]);
  const [labelSelected, setLabelSelected] = React.useState("");
  const [newNodeValue, setNewNodeValue] = React.useState("");

  const titleFormatted = id ? `${title} [#${id}]` : title;

  const handleSelectedNode = (nodeId) => {
    const id = parseInt(nodeId, 10);
    const selectedNode = GraphNode.findNodeByIdInTree(id, graphClone);
    setSelected(id);
    setLabelSelected(selectedNode.label);
  };

  const handleNodeChange = (e) => {
    setLabelSelected(e.target.value);
  };

  const handleNewNodeChange = (e) => {
    setNewNodeValue(e.target.value);
  };

  const handleNewNodeSaveAction = () => {
    const nodeSelected = GraphNode.findNodeByIdInTree(selected, graphClone);
    if (nodeSelected && nodeSelected.label) {
      const graphUpdated = GraphNode.syncCategoriesTreeWithNodeUpdatedHandler(
        newNodeValue,
        nodeSelected,
        graphClone
      );
      onGraphChange(graphUpdated);
    } else {
      console.log(`Node '${id}' not found`);
    }
  };

  const handleNodeDeleteAction = () => {
    const graphUpdated = GraphNode.searchAndDeleteNodeGraph(
      graphClone,
      selected
    );
    onGraphChange(graphUpdated);
  };

  const handleNodeSaveAction = () => {
    const nodeSelected = GraphNode.findNodeByIdInTree(selected, graphClone);
    if (nodeSelected && nodeSelected.label) {
      const nodeUpdated = { ...nodeSelected, label: labelSelected };
      let cloneCategories = JSON.parse(JSON.stringify(graphClone));
      GraphNode.updateCategoriesTreeWithNewNode(nodeUpdated, cloneCategories);
      onGraphChange(cloneCategories);
    } else {
      console.log(`Node with id ${selected} not found`);
    }
  };

  const nodeIds = extractIDsFromGraph([], graphClone);

  return (
    <>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {titleFormatted}
      </Typography>

      <Box component="form" noValidate autoComplete="off">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper sx={{ p: 2, mb: 2 }}>
              <FormControl fullWidth>
                <TextField
                  label="Nom du menu"
                  margin="normal"
                  onChange={onTitleChange}
                  variant="outlined"
                  value={title}
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  label="Description"
                  margin="normal"
                  onChange={onDescriptionChange}
                  variant="outlined"
                  value={description}
                />
              </FormControl>
            </Paper>

            <Paper sx={{ p: 2, mb: 2 }}>
              {labelSelected !== "" && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <TextField
                    label="Menu sélectionné"
                    margin="normal"
                    onChange={handleNodeChange}
                    variant="outlined"
                    value={labelSelected}
                  />
                  <IconButton
                    edge="end"
                    disabled={submitting || labelSelected === ""}
                    aria-label="edit"
                    onClick={handleNodeSaveAction}
                    size="large"
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    edge="end"
                    disabled={submitting || labelSelected === ""}
                    aria-label="delete"
                    onClick={handleNodeDeleteAction}
                    size="large"
                  >
                    <DeleteIcon />
                  </IconButton>
                  <TextField
                    label="Nouveau sous-menu"
                    margin="normal"
                    onChange={handleNewNodeChange}
                    variant="outlined"
                    value={newNodeValue}
                  />
                  <IconButton
                    edge="end"
                    disabled={submitting}
                    aria-label="add"
                    onClick={handleNewNodeSaveAction}
                    size="large"
                  >
                    <AddIcon />
                  </IconButton>
                </Box>
              )}

              <Box sx={{ mt: 3, maxHeight: 400, overflow: "auto" }}>
                <Treeview
                  expanded={nodeIds}
                  categories={graphClone}
                  onSelectedNode={handleSelectedNode}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          mt: 5,
          py: 2,
        }}
      >
        <Button
          variant="contained"
          disabled={submitting || title === ""}
          onClick={onNodeSave}
        >
          {submitting ? "processing ..." : "Sauver"}
        </Button>
        <Button
          variant="contained"
          disabled={submitting}
          onClick={onCancelAction}
        >
          Annuler
        </Button>
      </Box>
    </>
  );
}
